<template>
  <div class="xbviews-container">
    <router-view></router-view>
  </div>
</template>

<script >
import {
  getToken,
  saveXBGuestSetting,
  removeXBGuestSetting,
  saveXBBasicInformation,
  getXBBasicInformation,
} from 'common/js/storage';
import XBHome from 'models/xb/home.js';

const xbHome = new XBHome();
export default {
  data() {
    return {
      labelLogo: ''
    };
  },
  watch: {
    labelLogo: function(newvalue, oldvalue) {
      let link = `<link rel="icon" href="${this.labelLogo}">`;
      let tempNode = document.createElement('div');
      tempNode.innerHTML = link;
      document.querySelector('head').append(tempNode.firstChild);
    }
  },
  created() {
    this.basicInformation();
  },
  mounted() {
    this.getGuestData(); // 游客数据
  },
  methods: {
    // 获取基础信息
    basicInformation() {
      xbHome.getXBBasicInformation().then(res => {
        if (res.success) {
          this.labelLogo = res.result.labelLogo;
          document.querySelector('title').innerHTML = res.result.mallName;
          saveXBBasicInformation(res.result);
          this.labelLogo = getXBBasicInformation().labelLogo;
          document.querySelector(
            'title'
          ).innerHTML = getXBBasicInformation().mallName;
        }
      });
    },
    // 获取游客进入数据
    getGuestData() {
      this.token = getToken() ? getToken() : '';
      if (this.token === '') {
        xbHome.getXBGuestSetting().then(res => {
          if (res.success) {
            if (res.result.guestLogin === 0) {
              if (
                this.$route.name !== 'user-login' &&
                this.$route.name !== 'user-register' &&
                this.$route.name !== 'user-password'
              ) {
                this.$router.push({ path: '/user-login' });
              }
              removeXBGuestSetting()
            } else {
              saveXBGuestSetting(res.result);
            }
          }
        });
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.xbviews-container {
  min-height: 100vh;
  position: relative;
  background: rgba(247, 247, 247, 1);
}
</style>
<style lang="scss">
.el-button {
  line-height: 0px;
}
.el-input.xb-gray {
  .el-input__inner {
    height: 40px;
    background: rgba(234, 238, 245, 0.2);
    border-radius: 4px;
    border: 1px solid rgba(234, 238, 245, 1);
  }
  .el-input__inner:hover {
    border-color: rgba(192, 196, 204, 1);
  }
  .el-input__inner:focus {
    border-color: rgba(61, 116, 242, 1);
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
    cursor: pointer;
  }
}
.el-input.xb-white {
  .el-input__inner {
    height: 40px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(235, 238, 242, 1);
  }
  .el-input__inner:hover {
    border-color: rgba(192, 196, 204, 1);
  }
  .el-input__inner:focus {
    border-color: rgba(61, 116, 242, 1);
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
    cursor: pointer;
  }
}
.el-input.xb-disabled {
  .el-input__inner {
    height: 40px;
    background: rgba(227, 231, 237, 0.5);
    border-radius: 4px;
    border: 1px solid rgba(219, 223, 230, 1);
  }
}
.el-cascader.xb-gray {
  .el-input--suffix {
    .el-input__inner {
      height: 40px;
      background: rgba(234, 238, 245, 0.2);
      border-radius: 4px;
      border: 1px solid rgba(234, 238, 245, 1);
    }
    .el-input__inner:hover {
      border-color: rgba(192, 196, 204, 1);
    }
    .el-input__inner:focus {
      border-color: rgba(61, 116, 242, 1);
    }
  }
}
.el-select.gray {
  .el-input__inner {
    height: 32px;
    line-height: 32px;
    background: rgba(234, 238, 245, 0.2);
    border-radius: 4px;
    border: 1px solid rgba(234, 238, 245, 1);
    padding: 0 20px 0 8px;
    font-size: 14px;
    font-family: "PingFangSC-Regular";
    color: rgba(96, 98, 102, 1);
    letter-spacing: 1px;
    padding-left: 15px;
  }
  .el-input__suffix {
    height: 40px;
    top: 0px;
    right: 0px;
  }
  .is-focus {
    .el-input__inner {
      border: 1px solid rgba(61, 116, 242, 1);
    }
  }
}
.el-select.white {
  .el-input__inner {
    height: 32px;
    line-height: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(234, 238, 245, 1);
    padding: 0 20px 0 8px;
    font-size: 14px;
    font-family: "PingFangSC-Regular";
    color: rgba(96, 98, 102, 1);
    letter-spacing: 1px;
    padding-left: 15px;
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
  }
  .is-focus {
    .el-input__inner {
      border: 1px solid rgba(61, 116, 242, 1);
    }
  }
}
.el-cascader {
  width: 300px;
  height: 32px;
  line-height: 32px;
  .el-input {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
      background: rgba(234, 238, 245, 0.2);
      border: 1px solid #eaeef5;
    }
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
  }
  .is-focus {
    .el-input__inner {
      border: 1px solid rgba(61, 116, 242, 1);
    }
  }
}
.el-input.gray {
  .el-input__inner {
    height: 32px;
    line-height: 32px;
    background: rgba(234, 238, 245, 0.2);
    border-radius: 4px;
    border: 1px solid rgba(234, 238, 245, 1);
  }
  .el-input__inner:hover {
    border-color: rgba(192, 196, 204, 1);
  }
  .el-input__inner:focus {
    border-color: rgba(61, 116, 242, 1);
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
    cursor: pointer;
  }
}
.el-input.white {
  .el-input__inner {
    height: 32px;
    line-height: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(235, 238, 242, 1);
  }
  .el-input__inner:hover {
    border-color: rgba(192, 196, 204, 1);
  }
  .el-input__inner:focus {
    border-color: rgba(61, 116, 242, 1);
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
    cursor: pointer;
  }
}
.table-img {
  .el-table {
    font-family: "PingFangSC-Regular";
    border: 1px solid #f2f6fc;
    border-bottom: 0;
    border-radius: 8px 8px 0px 0px;
    .el-table__empty-block {
      background: #fff;
    }
    .el-table__header-wrapper {
      background: #f5f7fa;
      .el-table__header {
        tr {
          th {
            background: #f5f7fa;
            padding: 0;
            .cell {
              color: #606266;
              line-height: 32px;
              height: 32px;
              font-size: 14px;
              letter-spacing: 1px;
              padding: 0 16px;
            }
          }
        }
      }
    }
    .el-table__body-wrapper {
      .el-table__body {
        tr {
          min-height: 54px;
          td {
            min-height: 54px;
            padding: 2px 0px;
            .cell {
              color: #606266;
              /* height: 64px; */
              padding: 5px 16px;
              font-size: 12px;
              /* line-height: 64px; */
              display: flex;
              justify-content: flex-start;
              align-items: center;
              letter-spacing: 1px;
              line-height: 16px;
              font-family: "Microsoft YaHei";
              .img {
                width: 40px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                margin-right: 16px;
              }
              .name {
                width: 240px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                font-size: 12px;
                line-height: 23px;
                letter-spacing: 0px;
              }
              .el-button {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
.el-form {
  .is-success {
    .el-input__inner:focus {
      border-color: #3d74f2;
    }
  }
  .el-form-item {
    margin-bottom: 16px;
    .el-form-item__label {
      line-height: 32px;
      color: #606266;
      padding: 0;
    }
    .el-form-item__content {
      line-height: 32px;
      .el-form-item__error {
        padding-top: 2px;
      }
    }
  }
}
</style>
